import { memo, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const RemoveConditional = ({ editingConditional, onDelete, columnName }) => {
  const [removeModalOpen, setRemoveModalOpen] = useState(false);

  const handleOpenRemoveModal = () => {
    setRemoveModalOpen(true);
  };

  const handleCloseRemoveModal = () => {
    setRemoveModalOpen(false);
  };

  const handleConfirmRemove = () => {
    onDelete(editingConditional.id);
    setRemoveModalOpen(false);
  };

  if (!editingConditional) return null;

  return (
    <>
      <Button
        fullWidth
        variant="outlined"
        onClick={handleOpenRemoveModal}
        sx={{
          mt: 2,
        }}
      >
        Remove column rule
      </Button>

      <Dialog open={removeModalOpen} onClose={handleCloseRemoveModal} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Remove {columnName}
          <IconButton onClick={handleCloseRemoveModal} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Divider />
        <DialogContent>Are you sure you want to remove the {columnName} column rule?</DialogContent>
        <Divider />

        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button onClick={handleCloseRemoveModal} variant="outlined" fullWidth>
            Discard
          </Button>
          <Button onClick={handleConfirmRemove} variant="contained" fullWidth disableElevation color="error">
            Remove
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default memo(RemoveConditional);
